export default {
  default: () => import("/Users/dreckr/workspace/nuxt-ember/src/layouts/default.vue").then(m => m.default || m)
}